import type { SVGProps } from 'react';
const SvgLogoShort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="m22.746 10.664-2.709-.263h-.02a7.18 7.18 0 0 1-4.367-2.064 7.2 7.2 0 0 1-2.063-4.35v-.061l-.283-2.692A1.324 1.324 0 0 0 11.99 0c-.708 0-1.274.546-1.335 1.234l-.262 2.732v.04A7.14 7.14 0 0 1 8.33 8.359a7.18 7.18 0 0 1-4.367 2.064h-.06l-2.67.242A1.344 1.344 0 0 0 0 12c0 .708.546 1.275 1.233 1.336l2.69.263h.04c1.597.162 3.154.83 4.367 2.064a7.2 7.2 0 0 1 2.063 4.35v.061l.262 2.692c.061.688.627 1.234 1.335 1.234s1.274-.546 1.334-1.234l.263-2.712v-.04c.162-1.6.83-3.137 2.063-4.351a7.18 7.18 0 0 1 4.367-2.064h.08l2.67-.263A1.344 1.344 0 0 0 24 12c-.04-.708-.566-1.275-1.254-1.336"
      fill="currentColor"
    />
  </svg>
);
export default SvgLogoShort;
